import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ColorPickerModule } from "ngx-color-picker";
import { DropzoneModule } from "../../sb-editor-tools/directives/dropzone/dropzone.module";
import { ExternalbtnComponent } from "../../sb-editor-tools/externalbtn/externalbtn.component";
import { LogoComponent } from "../../sb-editor-tools/logo/logo.component";
import { TitlesComponent } from "../../sb-editor-tools/titles/titles.component";
import { HeaderComponent } from "./header.component";
import { TopbarComponent } from '../../sb-editor-tools/topbar/topbar.component';
import { LogofaviconComponent } from './logofavicon/logofavicon.component';
import { FaviconComponent } from "../../sb-editor-tools/favicon/favicon.component";



@NgModule({
    declarations: [
        HeaderComponent,
        LogoComponent,
        TitlesComponent,
        ExternalbtnComponent,
        TopbarComponent,
        LogofaviconComponent,
        FaviconComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DropzoneModule,
        ColorPickerModule
    ],
    providers: [],
    exports:[
        HeaderComponent
    ]
})
export class HeaderModule {}